var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcVideoOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M1.707.293A1 1 0 0 0 .293 1.707l2.62 2.62A4 4 0 0 0 .5 8v8a4 4 0 0 0 4 4h9c1.382 0 2.6-.701 3.319-1.767l5.474 5.474a1 1 0 0 0 1.414-1.414zm13.642 16.47L4.586 6H4.5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9a2 2 0 0 0 1.85-1.237z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.51 12.085a1.01 1.01 0 0 1-1.01-1.01V8a2 2 0 0 0-2-2h-2.086a1 1 0 1 1 0-2H13.5a4 4 0 0 1 3.982 3.619l3.386-1.129A2 2 0 0 1 23.5 8.387v7.226a1 1 0 1 1-2 0V8.387l-4 1.334v1.375c0 .55-.44.99-.99.99z"
})));
export default SvgIcVideoOff;